import { useMutation } from '@tanstack/react-query';

import { strapiClient } from '@/services/apiClient';

type UserType = 'customer' | 'vendor';

interface createMarketingUserPayload {
  email: string;
  userType: UserType;
}

const createMarketingUser = async ({
  email,
  userType,
}: createMarketingUserPayload) => {
  await strapiClient.post('/api/marketing-users', {
    data: { email, userType },
  });
};

export const useCreateMarketingUser = () => {
  return useMutation(({ email, userType }: createMarketingUserPayload) =>
    createMarketingUser({ email, userType }),
  );
};
